<template>
  <div class="bg-gray-100">
    <div id="container ">
      <div id="flex flex-row">

        <div class="inline-flex border-r ">
          <button class="bar-button" :class="{'active':isBold}" @click.prevent="bold">
            <format-bold/>
          </button>
          <button class="bar-button" :class="{'active':isItalic}" @click.prevent="italize">
            <format-italic/>
          </button>
          <button class="bar-button" :class="{'active':isUnderlined}" @click.prevent="underline">
            <format-underline/>
          </button>
          <button class="bar-button" :class="{'active':isStrikedThrough}" @click.prevent="strikeThrough">
            <format-strikethrough/>
          </button>
          <button class="bar-button" :class="{'active':isHeading}" @click.prevent="showHeadings">
            <format-header-1/>
          </button>
        </div>

        <div class="inline-flex border-r">
          <button class="bar-button" :class="{'active':isAlignedLeft}" @click.prevent="alignLeft">
            <format-align-left/>
          </button>
          <button class="bar-button" :class="{'active':isAlignedCenter}" @click.prevent="alignCenter">
            <format-align-center/>
          </button>
          <button class="bar-button" :class="{'active':isAlignedRight}" @click.prevent="alignRight">
            <format-align-right/>
          </button>
          <button class="bar-button" @click.prevent="orderedList">
            <format-list-numbered/>
          </button>
          <button class="bar-button" @click.prevent="insertUnorderedList">
            <format-list-bulleted/>
          </button>
        </div>

        <div class="inline-flex">
          <!--
          <button class="bar-button" :class="{'active':showLinkForm}" @click.prevent="showLinkOptions">
            <b>URL</b>
          </button>
          -->
          <!--         <button class="bar-button">
                     <ui-dropdown boxClass="w-auto" @click="showTableOptions">
                       <template #button>
                         <table-large/>
                       </template>
                       <template #default>
                         <form @submit.prevent="createTable">
                           <input v-model="rows" min="0" type="number" placeholder="Строки" required/>
                           <input v-model="cols" min="0" type="number" placeholder="Столбцы" required/>
                           <button type="submit" class="wysiwyg-button">Добавить</button>
                           <button @click.prevent="rows = null; cols = null" class="wysiwyg-button">Очистить</button>
                         </form>

                         <div class="hoverTableCont">
                           <div class="hoverTable" @mouseleave="changeSelectedCell(0, 0)">
                             <div class="hoverRow" v-for="(row, key) in 12" :key="key">
                               <div
                                   v-for="(col, key) in 12"
                                   :class="['hoverCell', { 'highlightCell': isHighlighted(row, col)}]"
                                   @mouseover="changeSelectedCell(row, col)"
                                   @click="setupCreateTable"
                                   :key="key"
                               ></div>
                             </div>
                           </div>
                           <br>
                           <div>
                             <em v-if="noSelectedCell">Select boxes above</em>
                             <em v-else>{{ selectedCell.cols }} x {{ selectedCell.rows }}</em>
                           </div>
                         </div>
                       </template>
                     </ui-dropdown>
                   </button>-->
          <button class="bar-button" :class="{'active':showTableForm}" @click.prevent="showTableOptions">
            <table-large/>
          </button>
          <button class="bar-button" @click.prevent="indent">
            <format-indent-increase/>
          </button>
          <button class="bar-button" @click.prevent="outdent">
            <format-indent-decrease/>
          </button>
        </div>
      </div>


      <!-- OPTIONS -->
      <div v-if="showHeadingOptions" class="bar-options">
        <button class="wysiwyg-button wysiwyg-button-loop" v-for="size in hSizes" :key="size"
                @click.prevent="heading(size)">{{ size }}
        </button>
      </div>

      <!--
      <div v-if="showLinkForm" id="toolbar-options">
        <form @submit.prevent="createLink">
          <input v-model="linkText" type="text" placeholder="Link Text" required/>
          <input v-model="linkURL" type="text" placeholder="URL" required/>
          <button type="submit" class="wysiwyg-button">Insert</button>
          <button @click.prevent="linkText = ''; linkURL = ''" class="wysiwyg-button">Clear</button>
        </form>
      </div>
      -->

      <div v-if="showTableForm" class="bar-options">
        <form @submit.prevent="createTable">
          <input v-model="rows" min="0" type="number" placeholder="Строки" required/>
          <input v-model="cols" min="0" type="number" placeholder="Столбцы" required/>
          <button type="submit" class="wysiwyg-button">Добавить</button>
          <button @click.prevent="rows = null; cols = null" class="wysiwyg-button">Очистить</button>
        </form>

        <div class="hoverTableCont">
          <div class="hoverTable" @mouseleave="changeSelectedCell(0, 0)">
            <div class="hoverRow" v-for="(row, key) in 12" :key="key">
              <div
                  v-for="(col, key) in 12"
                  :class="['hoverCell', { 'highlightCell': isHighlighted(row, col)}]"
                  @mouseover="changeSelectedCell(row, col)"
                  @click="setupCreateTable"
                  :key="key"
              ></div>
            </div>
          </div>
          <br>
          <div>
            <em v-if="noSelectedCell">Select boxes above</em>
            <em v-else>{{ selectedCell.cols }} x {{ selectedCell.rows }}</em>
          </div>
        </div>

      </div>

      <div id="body" class="bg-white border" :style="{'height': `${height}px`}">
        <div id="editor" contenteditable :style="{'min-height': `${height}px`}"></div>
      </div>
    </div>
  </div>
</template>

<script>


import FormatAlignCenter from "@/components/icons/FormatAlignCenter";
import FormatAlignLeft from '@/components/icons/FormatAlignLeft.vue';
import FormatAlignRight from '@/components/icons/FormatAlignRight.vue';
import FormatBold from '@/components/icons/FormatBold.vue';
import FormatHeader1 from '@/components/icons/FormatHeader1.vue';
import FormatIndentDecrease from '@/components/icons/FormatIndentDecrease.vue';
import FormatIndentIncrease from '@/components/icons/FormatIndentIncrease.vue';
import FormatItalic from '@/components/icons/FormatItalic.vue';
import FormatListBulleted from '@/components/icons/FormatListBulleted.vue';
import FormatListNumbered from '@/components/icons/FormatListNumbered.vue';
import FormatStrikethrough from '@/components/icons/FormatStrikethrough.vue';
import FormatUnderline from '@/components/icons/FormatUnderline.vue';
import TableLarge from '@/components/icons/TableLarge.vue';

export default {
  name: 'UiBlockTextEditor',
  components: {
    FormatAlignCenter,
    FormatAlignLeft,
    FormatAlignRight,
    FormatBold,
    FormatHeader1,
    FormatIndentDecrease,
    FormatIndentIncrease,
    FormatItalic,
    FormatListBulleted,
    FormatListNumbered,
    FormatStrikethrough,
    FormatUnderline,
    TableLarge
  },
  props: {
    value: {
      type: String
    },
    modelValue: {
      default: ''
    },
    hide: {
      type: Object,
      default: () => ({})
    },
    height: {
      type: [Number, String],
      default: 400
    }
  },
  data() {
    return {
      isBold: false,
      isItalic: false,
      isUnderlined: false,
      isStrikedThrough: false,
      isHeading: false,
      isAlignedLeft: false,
      isAlignedCenter: false,
      isAlignedRight: false,
      showToolbarOptions: false,
      showHeadingOptions: false,
      showLinkForm: false,
      linkText: '',
      linkURL: '',
      showTableForm: false,
      rows: null,
      cols: null,
      selectedCell: {
        rows: 0,
        cols: 0
      },
      caratSelection: null,
      savedPosition: null
    };
  },
  computed: {
    hSizes() {
      let sizes = [];
      for (let x = 1; x <= 6; x++) {
        sizes.push(`H${x}`);
      }
      sizes.push('Clear');
      return sizes;
    },
    noSelectedCell() {
      return this.selectedCell.rows === 0 && this.selectedCell.cols === 0;
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            if (!document.getElementById('editor').innerHTML) {
              document.getElementById('editor').innerHTML = val;
            }
          }, 100);
        }
      },
      immediate: true
    }
  },
  methods: {
    bold() {
      this.isBold = !this.isBold;
      this.exec('bold');
    },
    italize() {
      this.isItalic = !this.isItalic;
      this.exec('italic');
    },
    underline() {
      this.isUnderlined = !this.isUnderlined;
      this.exec('underline');
    },
    strikeThrough() {
      this.isStrikedThrough = !this.isStrikedThrough;
      this.exec('strikeThrough');
    },
    heading(size) {
      this.exec('formatBlock', false, size === 'Clear' ? 'p' : size);
    },
    showHeadings() {
      this.isHeading = !this.isHeading;
      this.showHeadingOptions = !this.showHeadingOptions;
    },
    alignLeft() {
      this.isAlignedLeft = !this.isAlignedLeft;
      this.exec('justifyLeft');
    },
    alignCenter() {
      this.isAlignedCenter = !this.isAlignedCenter;
      this.exec('justifyCenter');
    },
    alignRight() {
      this.isAlignedRight = !this.isAlignedRight;
      this.exec('justifyRight');
    },
  /*  showLinkOptions() {
      this.showLinkForm = !this.showLinkForm;
    },
    createLink() {
      let selected = document.getSelection();
      if (selected.anchorOffset === selected.extentOffset)
        selected = this.linkText;
      this.exec('insertHTML', false, `<a href='${this.linkURL}'>${selected}</a>`);
    },*/
    orderedList() {
      this.exec('insertOrderedList');
    },
    insertUnorderedList() {
      this.exec('insertUnorderedList');
    },
    showTableOptions() {
      if (!this.showTableForm) {
        this.caratSelection = document.getSelection();
        this.savedPosition = [this.caratSelection.focusNode, this.caratSelection.focusOffset];
      }
      this.showTableForm = !this.showTableForm;
    },
    generateTable(rows, cols) {
      let text = '';
      for (let row = 1; row <= rows; row++) {
        text += `<tr>`;
        for (let col = 1; col <= cols; col++) {
          text += `<td style="border: 1px solid lightgrey; padding: 2px;"></td>`;
        }
        text += `</tr>`;
      }
      return text;
    },

    setupCreateTable() {
      this.rows = this.selectedCell.rows;
      this.cols = this.selectedCell.cols;
      this.createTable();
    },
    createTable() {
      document.getElementById('editor').focus();
      this.caratSelection.collapse(this.savedPosition[0], this.savedPosition[1]);
      let table = `
        <table width="100%" style="border-collapse: collapse; border: 1px solid lightgrey;">
          <tbody>
            ${this.generateTable(this.rows, this.cols)}
          </tbody>
        </table>
      `;

      this.exec('insertHTML', false, table);
      this.showTableForm = false;
      this.caratSelection = null;
      this.savedPosition = null;
    },
    indent() {
      this.exec('indent');
    },
    outdent() {
      this.exec('outdent');
    },
    changeSelectedCell(row, col) {
      this.selectedCell.rows = row;
      this.selectedCell.cols = col;
    },
    isHighlighted(row, col) {
      if (this.noSelectedCell) return false;
      if (row <= this.selectedCell.rows && col <= this.selectedCell.cols) return true;
      return false;
    },
    exec(...args) {
      document.execCommand(...args);
    },
    getValue() {
      //this.$emit('input', document.getElementById('editor').innerHTML);
      //this.$emit('update:modelValue', event.target.value)
      this.$emit('update:modelValue', document.getElementById('editor').innerHTML)
    }
  },
  mounted() {
    let that = this;
    this.$nextTick(() => {
      document.getElementById('editor').addEventListener('input', function () {
        that.getValue();
      }, false);
    });
    //document.execCommand('defaultParagraphSeparator', false, 'p');
  },
}
</script>

<style scoped lang="scss">

.bar-button {
  @apply text-center m-1 p-0.5 rounded;
  &.active {
    @apply bg-orange-100;
  }

  > * {
    @apply w-5 h-5
  }
}




input {
  margin: 4px;
  padding: 2px;
  border: 1px solid lightgrey;
}

input:focus {
  outline: none;
}

#container {
  border: 1px solid lightgrey;
}

#body {
  overflow: auto;
  display: inline-block;
  width: 100%
}

#editor {
  padding: 10px;
}

#toolbar {
  min-height: 29px;
  border-bottom: 1px solid lightgrey;
  background-color: rgb(247, 247, 247);
}

#toolbar-options {
  min-height: 29px;
  border-bottom: 1px solid lightgrey;
  overflow: hidden;
}

#editor:focus {
  outline: none;
}

.toolbar-section {
  float: left;
  border-right: 1px solid lightgrey;
}

/*.wysiwyg-button {
  height: 28px;
  min-width: 30px;
  //background-color: transparent;
  text-align: center;
  padding: 2px;
}

.wysiwyg-button:hover {
  background-color: lightblue;
}*/

/* .wysiwyg-button-active {
  background-color: lightblue;
} */

.wysiwyg-button-loop {
  margin-right: 4px;
}

.hoverTableCont {
  width: 230px;
  margin-right: 30px;
  float: left;
  padding: 15px 0px 0px 15px;
}

.hoverCell {
  border: 1px solid #aaa;
  height: 16px;
  width: 16px;
  margin: 0 1px 1px 0;
  float: left;
  cursor: pointer;
}

.hoverCell:hover {
  background-color: #4b67a1 !important;
}

.hoverRow {
  display: block;
  clear: both;
}

.highlightCell {
  background-color: #d1e0ff;
}
</style>